<custom-modal [(open)]="isShowExitModal" [modalClass]="'marine-insurance-reminder'">
  <div class="marine-insurance-reminder-content">
    <div class="marine-insurance-reminder-hero">
      <div class="marine-insurance-reminder-hero-eyebrow">
        <span class="marine-insurance-reminder-hero-eyebrow-icon">
          <img src="/assets/icons/icon_insured_active.svg" alt="" />
        </span>
        {{ "MARINE_INSURANCE_REMINDER.EYEBROW" | translate }}
      </div>

      <h2 class="marine-insurance-reminder-hero-title">{{ "MARINE_INSURANCE_REMINDER.HEADER" | translate }}</h2>
      <p class="marine-insurance-reminder-hero-subtitle">{{ "MARINE_INSURANCE_REMINDER.SUB_HEADER" | translate }}</p>
    </div>

    <div class="marine-insurance-reminder-body">
      <div class="marine-insurance-reminder-warning">
        <i class="fa fa-exclamation-triangle marine-insurance-reminder-warning-icon"></i>
        <span [innerHTML]="'MARINE_INSURANCE_REMINDER.WARNING' | translate"></span>
      </div>

      <div class="marine-insurance-reminder-coverage-title">{{ "MARINE_INSURANCE_REMINDER.COVERAGE_TITLE" | translate }}</div>

      <div class="marine-insurance-reminder-features">
        <div class="marine-insurance-reminder-feature" *ngFor="let feature of features">
          <span class="marine-insurance-reminder-feature-tick">
            <i class="fa fa-check"></i>
          </span>

          <div class="marine-insurance-reminder-feature-text">
            <div class="marine-insurance-reminder-feature-title">{{ feature.TITLE }}</div>
            <div class="marine-insurance-reminder-feature-description">{{ feature.TEXT }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="marine-insurance-reminder-footer">
      <button type="button" class="marine-insurance-reminder-footer-accept" (click)="onAccept()">
        {{ "MARINE_INSURANCE_REMINDER.ACCEPT" | translate }}
      </button>

      <button type="button" class="marine-insurance-reminder-footer-decline" (click)="onDecline()">
        {{ "MARINE_INSURANCE_REMINDER.DECLINE" | translate }}
      </button>
    </div>
  </div>
</custom-modal>
